import { PermisosState } from "./state";

export default {
  users: (s: PermisosState) => s.users,
  permsCatalog: (s: PermisosState) => s.permsCatalog,
  detail: (s: PermisosState) => s.detail,

  loadingUsers: (s: PermisosState) => s.loadingUsers,
  loadingPerms: (s: PermisosState) => s.loadingPerms,
  loadingDetail: (s: PermisosState) => s.loadingDetail,
  saving: (s: PermisosState) => s.saving,

  errorMessage: (s: PermisosState) => s.errorMessage,
};